import React, {useEffect, useState} from "react";

import VLFModal from "@/components/Modal";
import VLFSelectNew from "@/components/Input/SelectNew";

import {REQUIRED_FIELD} from "@/utils/constants";
import {checkRequiredFields} from "@/utils/functions";

const requiredFields = ["player"];

function HandleMedicalRecordModal(props) {
	const {open, players, confirm, close} = props;

	const [formData, setFormData] = useState({
		player: null,
	});
	const [errors, setErrors] = useState([]);

	useEffect(() => {
		if (!open) {
			setFormData({player: null});
		}
	}, [open]);

	const handleFieldOnChange = (key, value) => {
		setErrors([]);
		setFormData({...formData, [key]: value});
	};

	return (
		<VLFModal
			maxWidth="sm"
			open={open}
			title="Nuova cartella medica"
			close={close}
			confirm={() => {
				const errors = checkRequiredFields(requiredFields, formData);
				setErrors(errors);

				if (!errors.length) {
					confirm(formData);
				}
			}}
			content={
				<div className="row">
					<div className="col-12">
						<VLFSelectNew
							options={players}
							value={formData.player}
							onChange={(newValue) => {
								handleFieldOnChange("player", newValue);
							}}
							label="Giocatore"
							size="small"
							placeholder="Giocatore"
							sortKey="sortKey"
							required
							helperText={errors.indexOf("player") !== -1 ? REQUIRED_FIELD : ""}
							error={errors.indexOf("player") !== -1}
						/>
					</div>
				</div>
			}
		/>
	);
}

export default HandleMedicalRecordModal;
